import CarouselRender from './CarouselRender';

export default CarouselRender;
